import { defineComponent as _defineComponent } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import {
  MAX_EDUCATIONAL_HISTORIES,
  descriptionMaxLength,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeEduHistoryCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()

return { __sfc: true,formatData, activeHistoryItem, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, HistoryItem, MAX_EDUCATIONAL_HISTORIES, descriptionMaxLength }
}

})